import { render, staticRenderFns } from "./PartnerIndicators.vue?vue&type=template&id=61ddef2e&scoped=true&"
import script from "./PartnerIndicators.vue?vue&type=script&lang=js&"
export * from "./PartnerIndicators.vue?vue&type=script&lang=js&"
import style0 from "./PartnerIndicators.vue?vue&type=style&index=0&id=61ddef2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddef2e",
  null
  
)

export default component.exports